import { render, staticRenderFns } from "./StoreCreate.vue?vue&type=template&id=4742885c&"
import script from "./StoreCreate.vue?vue&type=script&lang=js&"
export * from "./StoreCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports